import React, {Component} from 'react';
import {NavBar, SearchBar, Toast} from 'antd-mobile';
import BMap from "BMap";
import {isDelivery,translate} from '../../../service/homeService';
import "./style.less";
import {connect} from "react-redux";
const mapImg = require('../../../common/image/position.png');
let map,point,geolocation,gc,poi,ls,endStationId,startStationId;
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class SelAddress extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            errorTips: [
                '',
                '您当前所在位置超出接送范围！',
                '超出接送范围，请重新选择！',
                '无法精确定位到当前位置，请重新选择！',
            ],
            curTips: '',
            isError: false,
            address:'',
            searchValue:'',
            poiList:[],
            poiListFlag:false,
            siteCityFlag:true,
            cityModal:false,
            modalType:'',
            citySearch:'',
            cityData:[],
            endStation:[],
            passStation:[],
            haveChangeAddress:false,//是否拖拽过地图，默认未拖拽过
            addressCanBeUse:false,//地址是否可用 more不可用
            endPoint:'',
            endCity:'',
            startCity:'',
            startStationId:'',
            // startStationId:this.props.location.state.startStationId ?this.props.location.state.startStationId :'',
            // endStationId:this.props.location.state.endStationId ? this.props.location.state.endStationId :'',
        };
    }
    componentDidMount() {
        poi = null;
        // point = null;
        //需要在这里根据上个页面传递过来的起止点设置为地图中心点。并将初始的上下车地址设置为起止点地址。
        this.setState({address:this.props.location.startPointName});
        const self = this;
        map = new BMap.Map('mapContainer');
        gc = new BMap.Geocoder();
        if(this.props.location.startPoint){
            point = this.props.location.startPoint.split(","); 
            // map.centerAndZoom(new BMap.Point(parseFloat(point[0]),parseFloat(point[1])), 15);
            this.convertjwd(point[1],point[0],5,(r)=>{
                map.centerAndZoom(new BMap.Point(r.split('_')[1],r.split('_')[0]), 15);
            })
        }
        if(this.props.location.endStation){
            let endStationArray = this.props.location.endStation
            endStationArray.forEach(e => {
              if(e.end == 1){
               this.state.endStation.push({
                    address:e.address,
                    location:e.location,//经纬度
                    id:e.id,
                    city:e.city
                })
              }else{
                this.state.passStation.push({
                    address:e.address,
                    location:e.location,//经纬度
                    id:e.id,
                    city:e.city
                })
              }
            });
        }
        ls = new BMap.LocalSearch(map, {
            onSearchComplete: (res) => {
                let s = [];
                if (res) {
                    for (var i = 0; i < res.getCurrentNumPois(); i++) {
                        s.push(res.getPoi(i))
                    }
                    self.setState({
                        poiList: s,
                    });
                }
            },
        });
        map.addEventListener('dragend', function (e) {
                let centerPoint = map.getCenter();
                gc.getLocation(centerPoint, function (res) {
                    if (res.surroundingPois.length) {
                        let firstPoint = res.surroundingPois[0];
                        self.setData(self, firstPoint.title, firstPoint.point.lng, firstPoint.point.lat, false, 0,true,true);
                    } else {
                        self.setData(self, '', '', '', true, 3,true,false);
                    }
                });
        });

    }
    convertjwd(lat,lng,type,callback){
        let params = {
            token:this.props.userInfo.token,
            data:{
                position:lat+'_'+lng,
                type:type,
            }
        }
        translate(params).then((res) => {
            if (res.data.code === '0000') {
                return callback(res.data.data)
            }else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }else {
                Toast.info(res.data.msg);
            }
        })
    }
    selPoi(res){
        let props = this.props.location.datas;
        if(props.type == 'start'){
            map.setCenter(res.point);
            this.setData(this, res.title, res.point.lng, res.point.lat, false, 0,false,false);
            this.setState({poiListFlag:false,searchValue:'',poiList: []});
        }else{
            map.setCenter(res.point);
            this.setData(this, res.title, res.point.lng, res.point.lat, false, 0,false,false);
            this.setState({poiListFlag:false,searchValue:'',poiList: []});
        }
    }
    searchChange=(value)=>{
        this.setState({ searchValue:value ,poiListFlag:true});
        this.tabDOM.scrollTop = 0;
        ls.search(value);
    };
    onClear=()=>{
        this.setState({poiList: [],poiListFlag:false,searchValue:'',siteCityFlag:false});
    };


    onClose = () => {
        this.setState({
            cityModal: false,
            cityData: [],
            citySearch: '',
        });
    };


    toggleCity=()=>{
        this.setState({poiList: [],searchValue:'',cityModal: true,siteCityFlag:true,poiListFlag:false});
        const params = {
            keyWords: '',
            // modalType:props.type,
            modalType:'start',
        };

    };



    changeCity(type,poin,n,k,j){
        // poi = null;
        point = poin.split(',');
        this.setData(this,n.address,point[0],point[1],false,0,false,false)
        if(type === 'pass'){
            let p =  poin.split(',')
            this.setState({
                address:n.address,
                siteCityFlag: false,
                endPoint:p,
                endCity:n.city,
                endStationId:n.id
            });
            // map.centerAndZoom(new BMap.Point(p[0],p[1]),15);
            this.convertjwd(p[1],p[0],5,(r)=>{
                map.centerAndZoom(new BMap.Point(r.split('_')[1],r.split('_')[0]), 15);
            })
            endStationId = n.id;
        }
        if(type === 'end'){
            let p =  poin.split(',')
            this.setState({
                address:n,
                siteCityFlag: false,
                endPoint:p,
                endCity:j,
                endStationId:k
            });
            endStationId = k;
            // map.centerAndZoom(new BMap.Point(p[0],p[1]),15);
            this.convertjwd(p[1],p[0],5,(r)=>{
                map.centerAndZoom(new BMap.Point(r.split('_')[1],r.split('_')[0]), 15);
            })
        }
        if(type === 'start'){
            let p =  poin.split(',')
            this.setState({
                address:n.address,
                siteCityFlag: false,
                startCity:n.city,
                startPoint:n.location,//出发地址经纬度
                startStationId:n.id
            });
          
            startStationId = n.id
            // map.centerAndZoom(new BMap.Point(p[0],p[1]),15);
            this.convertjwd(p[1],p[0],5,(r)=>{
                map.centerAndZoom(new BMap.Point(r.split('_')[1],r.split('_')[0]), 15);
            })
        }
    }

    /**
     * evented 是否拖拽过
     * canbeUsed 地址是否可用
     */
    setData = (self, title, lng, lat, boolean, index,evented,canbeUsed) => {
        self.setState({
            address: title,
            isError: boolean,
            curTips: self.state.errorTips[index],
            addressCanBeUse:canbeUsed,
            haveChangeAddress:evented
        });
        poi = {
            lng: lng,
            lat: lat,
            address: title,
        };//经纬度以及地点
    };

    goSelClass(){
        //确认上车下车的时候，判断是否在接送范围内
    //     let params = {
    //         token: this.props.userInfo.token,
    //         data:{
    //             id: this.props.location.datas.type === 'start' ? this.state.startStationId : endStationId,
    //             position: poi ? (poi.lat + '_' + poi.lng) : (point.length > 0 ? (point[1] + '_' + point[0]):point )   
    //         }
    //     };
    //     isDelivery(params).then((res) => {
    //         if (res.data.code === '0000') {
    //             var state = this.props.history.location.datas;
    //             if(this.state.haveChangeAddress){
    //                 if(!this.state.addressCanBeUse){
    //                     //地址不可用，提示用户重新选择地址
    //                     console.log('地址不可用，提示用户重新选择地址')
    //                     return;
    //                 }
    //                 state.returnData({
    //                     type:state.type,
    //                     address:this.state.address,
    //                     point:poi,
    //                     endCity:this.state.endCity,
    //                     endStationId:this.state.endStationId,
    //                     startStationId:startStationId
    //                 });//把确认好的经纬度传过去
                    
    //             }else{
    //                 state.returnData({
    //                     type:state.type,
    //                     address:this.state.address,
    //                     point: poi ? poi : point,
    //                     endCity:this.state.endCity,
    //                     endStationId:this.state.endStationId,
    //                     startStationId:startStationId
    //                 });
    //             }
    //             this.props.history.goBack();
    //         }
    //         else if (res.data.code === '1401') {
    //           document.location = `js://toLogin?token=${this.props.userInfo.token}`;
    //         }
    //         else {
    //             Toast.info(res.data.msg);
    //         }
    //     }).catch(function (error) {
    //       console.log(error);
    //   });
    console.log(poi,point)
    let rr = ''
    let newpoi = poi
    this.convertjwd(poi.lat,poi.lng,6,(r)=>{
        if(point.length > 0 && point[0] == poi.lng){
            rr = poi.lat + '_' + poi.lng 
        }else{
            rr = r
            newpoi.lat = r.split('_')[0]
            newpoi.lng = r.split('_')[1]
        }
        let params = {
            token: this.props.userInfo.token,
            data:{
                id: this.props.location.datas.type === 'start' ? this.state.startStationId : endStationId,
                position: rr   
            }
        };
        isDelivery(params).then((res) => {
            if (res.data.code === '0000') {
                var state = this.props.history.location.datas;
                if(this.state.haveChangeAddress){
                    if(!this.state.addressCanBeUse){
                        //地址不可用，提示用户重新选择地址
                        console.log('地址不可用，提示用户重新选择地址')
                        return;
                    }
                    state.returnData({
                        type:state.type,
                        address:this.state.address,
                        point:newpoi,
                        endCity:this.state.endCity,
                        endStationId:this.state.endStationId,
                        startStationId:startStationId
                    });//把确认好的经纬度传过去
                    
                }else{
                    state.returnData({
                        type:state.type,
                        address:this.state.address,
                        point: newpoi,
                        endCity:this.state.endCity,
                        endStationId:this.state.endStationId,
                        startStationId:startStationId
                    });
                }
                this.props.history.goBack();
            }
            else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }
            else {
                Toast.info(res.data.msg);
            }
        })
    })
       
    }
    render(){
        const props = this.props.location.datas;
        const locationDatas = this.props.location;
        var addressStr = '';
        var addressStrLocation = '';
        var  addressLocation ='';
        var addressLocationId = '';
        if(typeof locationDatas != 'undefined' && typeof locationDatas.endStation != 'undefined' && locationDatas.endStation.length > 0){
            locationDatas.endStation.forEach(e => {
                if(e.end == 1){
                addressStr = e.city;
                addressStrLocation = e.location;
                addressLocation = e.address;
                addressLocationId = e.id;
                }
            })
        }
        // console.log(locationDatas)
        return(
            <div className="selAddress">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >{props.type == 'start' ? '上车地址' : '下车地址'}</NavBar>
                <div id="mapContainer"/>
                {
                    this.state.isError ? <div className="errTips"><span>{this.state.curTips}</span></div> : null
                }
                <img className="mapIcon" src={mapImg} alt=""/>
                <div className="topBar">
                {
                    locationDatas.startCity ? 
                        /* (<div className="selCity"><span style={{paddingRight: "10px"}}>{locationDatas.startCity}</span></div>)  */
                        (<div className="selCity" onClick={this.toggleCity}><span>{this.state.startCity ?this.state.startCity :this.props.location.startArray[0].city}</span><i className="icon iconfont iconzhandianxialaxuanze" /></div>)
                        :
                        (<div className="selCity" onClick={this.toggleCity}><span>{this.state.endCity ? this.state.endCity :addressStr}</span><i className="icon iconfont iconzhandianxialaxuanze" /></div>)
                }
                    <SearchBar
                        className="searchBar"
                        value={this.state.searchValue}
                        placeholder={props.type == 'start' ? '哪儿上车？' : '哪儿下车？'}
                        onChange={this.searchChange}
                        showCancelButton={false}
                        onCancel={this.onClear}
                        onClear={this.onClear}
                    />
                </div>
                <div className="bottom">
                   <div className="addressText">
                       <i className="icon iconfont icondaixiadanchufadi"/>
                       <div>{this.state.address ? this.state.address : props.address}</div>
                   </div>
                    <button onClick={()=>this.goSelClass()}>{props.type == 'start' ? '确认上车点' : '确认下车点'}</button>
                </div>

                <div className="poiList" style={this.state.poiListFlag == false  ? {height:'0'} : {height:'100%'}} ref={dom => {this.tabDOM = dom}}>
                    <div>
                       {/*  <div className="history"><i className="icon iconfont iconlishi"/>历史记录</div>
                        <div className="historyText">
                            文山市七花广场同德街大胜酒店的发防晒霜的说法是
            </div> */}
                        <div className="mapSel" onClick={this.onClear}><i className="icon iconfont iconditushangxuandian"/>在地图上选点</div>
                    </div>

                    {
                        this.state.poiList.length > 0 ? (
                            <div className="list">
                                {
                                    this.state.poiList.map((res, i) => (
                                        <div className="item"  key={i}  onClick={() => this.selPoi(res)} >
                                            <i className="icon iconfont icondituliebiaotubiao"/>
                                            <div>
                                                <div>{res.title}</div>
                                                <span>{res.address}</span>
                                            </div>
                                        </div>

                                    ))
                                }
                            </div>
                        ): <div className='tishi'>请输入搜索内容</div>
                    }

                </div>
                    {
                        props.type == 'end'? (<div className="siteCity" style={this.state.siteCityFlag == false  ? {display:'none'} : {display:'block'}}>
                        <div className="curtCity">
                            <p>终点站城市：</p><span onClick={() => this.changeCity('end',addressStrLocation,addressLocation,addressLocationId,addressStr)}>{addressStr}</span>
                        </div>
                        <div className="hotCity">
                            <div className="title">中间起止点</div>
                            <div className="hotText">
                                {
                                    this.state.passStation.length > 0 ? this.state.passStation.map((res,i)=>(
                                        <span key={i} onClick={() => this.changeCity('pass',res.location,res)}>{res.city}</span>
                                    )):<div>该行程无中间起止点</div>
                                }
                            </div>
                        </div>
                    </div>) :(
                        <div className="siteCity" style={this.state.siteCityFlag == false  ? {display:'none'} : {display:'block'}}>
                        <div className="hotCity">
                            <div className="title">出发起止点</div>
                            <div className="hotText">
                                {
                                    this.props.location.startArray.map((res,i)=>(
                                        <span key={i} onClick={() => this.changeCity('start',res.location,res)}>{res.city}</span>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    )
                    }
                
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Home/SelAddress/index.js